// import popup from './popup'
// import appConfig from '@/app.config.js'
class Upload {

    constructor() {

        this.file = null
        this.fileType = null
        this.allowedFileSize = process.env.VUE_APP_ALLOWED_UPLOAD_SIZE
        this.allowedFileTypes = []
    }

    addFile(file, type = 'image') {
        this.file = file
        this.fileType = type
        this.allowedFileTypes = [
            'image/png',
            'image/jpeg',
            'image/jpg',
            'image/gif',
            'image/webp',
            'video/mp4',
            'video/quicktime'
        ]

        if(file.type.includes('video')) {
            this.allowedFileSize = process.env.VUE_APP_ALLOWED_UPLOAD_VIDEO_SIZE
        }

        return this
    }

    validateFileType() {
        let validationType = this.allowedFileTypes

        return validationType.indexOf(this.file.type) > -1
    }

    validateFileSize() {

        if (this.file.ignore_validate) {
            return true
        }

        var fileSize = Math.floor(this.file.size / 1024 / 1024)

        return fileSize < this.allowedFileSize
    }

    validate(successCallback, failCallback) {

        if (!this.validateFileType() || this.file.type.includes("video")) {
            window.shout.error("Please upload only image file")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        if (!this.validateFileSize()) {

            window.shout.error("Your image large than " + this.allowedFileSize + "MB")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        successCallback()
        return true
    }

    validateVideo(successCallback, failCallback) {

        if (!this.validateFileType() || this.file.type.includes("image")) {

            window.shout.error("Please upload only MP4 file")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        if (!this.validateFileSize()) {

            window.shout.error("Your video large than " + this.allowedFileSize + "MB")

            if (typeof failCallback == 'function') {
                failCallback()
            }

            return false
        }

        successCallback()
        return true
    }
}

export default new Upload
